import styled from "@emotion/styled";
import React from "react";
import { MEDFLYT_LOGO_ICON_ONLY } from "../../../utils/svgs_new";
import { AppIcon } from "../../Generic/AppIcon";

interface Props {
  url: string | null;
  size?: number;
}

function ChatAvatar(props: Props) {
  return (
    <ChatAvatar.Root size={props.size ?? 32}>
      {props.url === null ? <AppIcon icon={MEDFLYT_LOGO_ICON_ONLY} /> : <img src={props.url} />}
    </ChatAvatar.Root>
  );
}

ChatAvatar.Root = styled.div<{ size: number }>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
  background-color: var(--blue);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: ${(props) => props.size / 1.7}px;
  }

  img {
    border-radius: 50%;
    width: 100%;
  }
`;

export default ChatAvatar;
